/* Source: src/mt-includes/widgets/content_slider/src/frontend/init.js*/
angular.module('website.widget.content_slider', [
    'website.core.utils',
    'website.core.widgets'
]);
